<template>
    <span>
        <v-select
            :class="{'stellar-select--inline': this.inline, 'stellar-select--full-bleed': !this.inline }"
            class="stellar-select"
            :placeholder="placeholder"
            :searchable=false
            v-model="value"
            :options="options">
        </v-select>
        <input type="hidden" :name="name" :value="hiddenInputValue"/>
    </span>
</template>
<script>
    import Vue from 'vue';
    import vSelect from 'vue-select';
    import VueResource from 'vue-resource';
    Vue.use(VueResource);
    Vue.component('v-select', vSelect);
    export default {
        props: {
            name: {
                type: String,
                required: true,
            },
            placeholder: {
                type: String,
            },
            options: {
                type: Array,
                required: true,
            },
            defaultSelected: {
                type: String,
            },
            inline: {
                type: Boolean,
            },
        },
        data: () => {
            return {
                value: null,
                hiddenInputValue: null,
            }
        },
        created () {
            if (this.defaultSelected) {
                this.value = this.defaultSelected
            }
        },
        watch: {
            value: function(option) {
                if (option) {
                    this.hiddenInputValue = option.id;
                } else {
                    this.hiddenInputValue = null;
                }
            }
        }
    }
</script>

